import { Button, Col, Form, Row, Tab, Table, Tabs } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../app/store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useRef, useState } from "react";
import {
    addListaMunicipiosDescarregamento,
    removeListaMunicipioDescarregamento
} from "../../../features/manifestoSlice";
import NFes from "./NFe/NFes";
import CTes from "./CTe/CTes";
import { JConfirmDelete, MensagemModal } from "../../../components/Components";
import { infMunDescargaInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import { getUuidV4 } from "../../../utils/utils";
import MDFes from "./MDFe/MDFes";

const initialSelect: SelectObjectRemoveInterface = {
    id: 0,
    title: ''
}

export default function InfDocumentos(props: any) {
    const dispatch = useDispatch();
    const [selected, setSelected] = useState<SelectObjectRemoveInterface>(initialSelect);
    const munDescarga = useSelector((state: RootState) => state.manifesto.manifesto.infMunDescarga);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState<string>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const selectMunicipiosCarregamento = useSelector((state: RootState) =>
        state.manifesto.selectMunicipiosCarregamentos);
    const munDescargaSelectRef = useRef<HTMLSelectElement>(null);

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(initialSelect);
    }

    const handleOpenModal = (value: SelectObjectRemoveInterface) => {
        setSelected(value);
        setShowModal(true);
    }

    const handleAdd = () => {
        const value = munDescargaSelectRef?.current?.value || ''

        if (value === "") {
            alerta('Na aba Principal, selecione uma UF Final para carregar os municípios.');
            return;
        }
        const nomeMunicipio = munDescargaSelectRef.current?.options[munDescargaSelectRef.current?.selectedIndex].text || '';

        if (value === '') {
            alerta('Informe um município.');
            return;
        }

        if (munDescarga.find(item => item.municipio_id === parseInt(value))) {
            alerta('Município já adicionado.');
            return;
        }

        dispatch(addListaMunicipiosDescarregamento(
            {
                id: getUuidV4(),
                municipio_id: parseInt(value),
                name: nomeMunicipio
            }
        ))
    }

    const handleRemover = (id: number) => {
        dispatch(removeListaMunicipioDescarregamento(id));
        setShowModal(false);
    }

    return (<div className="px-2">

        <Tabs defaultActiveKey="tab_municipio_descarregamento" id="tab-example" className="mb-3">
            <Tab eventKey="tab_municipio_descarregamento" title="Municípios de descarregamento">

                <Row className="g-2 mb-3">
                    <Col md={3}>
                        <Form.Group>
                            <Form.Label>Municípios</Form.Label>
                            <Form.Select name="municipio_carregamento" id="municipio_carregamento"
                                ref={munDescargaSelectRef} >
                                {selectMunicipiosCarregamento?.map((municipio: any) => (
                                    <option
                                        key={municipio.id} selected={municipio.capital === 1}
                                        value={municipio.id}>
                                        {municipio.name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                    </Col>

                    <Col md={'auto'} className="d-flex align-items-end">
                        <Form.Group>
                            <Button variant="primary" onClick={handleAdd}>
                                <FontAwesomeIcon icon={faPlus} /> Adicionar
                            </Button>
                        </Form.Group>
                    </Col>
                </Row>

                <h6 className="pb-2"><span className="text-dark">(100 no máximo)</span></h6>
                <Table striped bordered hover size="sm" responsive="sm">
                    <thead className="table-light">
                        <tr>
                            <th className="text-center" style={{ width: '2.5rem' }}>#</th>
                            <th>Município</th>
                        </tr>
                    </thead>
                    <tbody>
                        {munDescarga?.map((item: infMunDescargaInterface) => {
                            return (
                                <tr key={item.id}>
                                    <td className="text-center">
                                        <a href="#" className="text-danger" onClick={() =>
                                            handleOpenModal({ id: item.id, title: item.name })}>
                                            <i className="fas fa-trash"></i>
                                        </a>
                                    </td>
                                    <td>{item.name}</td>
                                </tr>
                            );
                        })}

                    </tbody>
                </Table>
            </Tab>

            <Tab eventKey="tab_md_nfe" title="Nota Fiscal Eletrônica (NF-e)" >
                <NFes />
            </Tab>

            {props.showDocumentoConhecimento && (
                <Tab eventKey="tab_md_cfe" title="Conhecimento Eletrônico (CT-e)" >
                    <CTes />
                </Tab>
            )}

            {props.showDocumentoManifesto && (
                <Tab eventKey="tab_md_mdfe" title="Manifesto Eletrônico de Documento (MDF-e)" >
                    <MDFes/>
                </Tab>
            )}
        </Tabs>

        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />

        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemover}
            selectedObject={selected.title}
            id={selected.id}
        />
    </div>);
}


